import React, { FunctionComponent } from 'react';

const url = require('resources/images/header-logo-spirit-loading.gif');

export const HeaderSkeleton: FunctionComponent<{
  backgroundColor?: string;
}> = ({ backgroundColor = '#5E6C84' }) => (
  <div
    style={{
      minHeight: 44,
      maxHeight: 44,
      backgroundColor,
    }}
  >
    <div
      style={{
        backgroundColor,
        height: 32,
        padding: '6px 4px',
        display: 'flex',
      }}
    >
      <div style={{ display: 'flex', flexGrow: 1 }}>
        <div
          style={{
            backgroundColor: 'hsla(0, 0%, 100%, 0.3)',
            height: 32,
            width: 32,
            borderRadius: 3,
            marginRight: 4,
          }}
        />
        <div
          style={{
            backgroundImage: `url(${url})`,
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            height: 32,
            width: 75,
            margin: '7px 8px 0px 2px',
            opacity: 0.5,
            position: 'relative',
            padding: '8px 0',
          }}
        />
        <div
          style={{
            alignItems: 'stretch',
            display: 'flex',
            flexGrow: 1,
            flexShrink: 0,
            flexBasis: 0,
            height: '100%',
            position: 'relative',
          }}
        >
          <div style={{ display: 'flex', margin: '0 4px' }}>
            <div
              style={{
                backgroundColor: 'hsla(0, 0%, 100%, 0.3)',
                height: 32,
                width: 124,
                borderRadius: 3,
                marginRight: 4,
              }}
            />
            <div
              style={{
                backgroundColor: 'hsla(0, 0%, 100%, 0.3)',
                height: 32,
                width: 90,
                borderRadius: 3,
                marginRight: 4,
              }}
            />
            <div
              style={{
                backgroundColor: 'hsla(0, 0%, 100%, 0.3)',
                height: 32,
                width: 90,
                borderRadius: 3,
                marginRight: 4,
              }}
            />
            <div
              style={{
                backgroundColor: 'hsla(0, 0%, 100%, 0.3)',
                height: 32,
                width: 110,
                borderRadius: 3,
                marginRight: 4,
              }}
            />
            <div
              style={{
                backgroundColor: 'hsla(0, 0%, 100%, 0.3)',
                height: 32,
                width: 68,
                borderRadius: 3,
                margin: '0px 4px 0 12px',
              }}
            />
          </div>
        </div>
      </div>
      <div style={{ display: 'flex', flexGrow: 1, justifyContent: 'flex-end' }}>
        <div
          style={{
            backgroundColor: 'hsla(0, 0%, 100%, 0.3)',
            height: 32,
            width: 250,
            borderRadius: 3,
            marginRight: 4,
          }}
        />
        <div
          style={{
            backgroundColor: 'hsla(0, 0%, 100%, 0.3)',
            height: 32,
            width: 32,
            borderRadius: 3,
            marginRight: 4,
          }}
        />
        <div
          style={{
            backgroundColor: 'hsla(0, 0%, 100%, 0.3)',
            height: 32,
            width: 32,
            borderRadius: 3,
            marginRight: 4,
          }}
        />
        <div
          style={{
            backgroundColor: 'hsla(0, 0%, 100%, 0.3)',
            height: 32,
            width: 32,
            borderRadius: 3,
            marginRight: 4,
          }}
        />
        <div
          style={{
            backgroundColor: 'hsla(0, 0%, 100%, 0.3)',
            height: 32,
            width: 32,
            borderRadius: 3,
            marginRight: 4,
          }}
        />
        <div
          style={{
            backgroundColor: 'hsla(0, 0%, 100%, 0.3)',
            height: 32,
            width: 32,
            borderRadius: '50%',
          }}
        />
      </div>
    </div>
  </div>
);
